var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriestRightArmTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 1,
    height: 1,
    fill: "#77550F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    width: 1,
    height: 1,
    fill: "#C59738"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 1,
    height: 1,
    fill: "#C59738"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 20,
    width: 1,
    height: 1,
    fill: "#77550F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 21,
    width: 1,
    height: 1,
    fill: "#77550F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 21,
    width: 1,
    height: 1,
    fill: "#AB7D1D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E5CB7E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E5CB7E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 21,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E5CB7E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 21,
    width: 1,
    height: 1,
    fill: "#AB7D1D"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 21,
    width: 1,
    height: 1,
    fill: "#77550F"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 1,
    height: 1,
    fill: "#AB7D1D"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E5CB7E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 22,
    width: 1,
    height: 1,
    fill: "#C59738"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22,
    width: 1,
    height: 1,
    fill: "#999275"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 22,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 1,
    height: 1,
    fill: "#C59738"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E5CB7E"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 1,
    height: 1,
    fill: "#AB7D1D"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 22,
    width: 1,
    height: 1,
    fill: "#77550F"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 23,
    width: 1,
    height: 1,
    fill: "#D4BC74"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23,
    width: 1,
    height: 1,
    fill: "#C59738"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 23,
    width: 1,
    height: 1,
    fill: "#999275"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 23,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 23,
    width: 1,
    height: 1,
    fill: "#AB7D1D"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 23,
    width: 1,
    height: 1,
    fill: "#C59738"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 23,
    width: 1,
    height: 1,
    fill: "#D4BC74"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23,
    width: 1,
    height: 1,
    fill: "#AB7D1D"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 1,
    height: 1,
    fill: "#999275"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 24,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 24,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A89168"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 24,
    width: 1,
    height: 1,
    fill: "#B0AC89"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 1,
    height: 1,
    fill: "#C5BFA7"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 24,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 25,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 25,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 25,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 25,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 25,
    width: 1,
    height: 1,
    fill: "#999275"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    width: 1,
    height: 1,
    fill: "#B0AC89"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 25,
    width: 1,
    height: 1,
    fill: "#C5BFA7"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 25,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 1,
    height: 1,
    fill: "#999275"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 26,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 26,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 26,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    width: 1,
    height: 1,
    fill: "#999275"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 26,
    width: 1,
    height: 1,
    fill: "#C5BFA7"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 26,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 27,
    width: 1,
    height: 1,
    fill: "#999275"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 27,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 27,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 27,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 27,
    width: 1,
    height: 1,
    fill: "#999275"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 27,
    width: 1,
    height: 1,
    fill: "#C5BFA7"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 27,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 28,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 28,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 28,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 1,
    height: 1,
    fill: "#999275"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 28,
    width: 1,
    height: 1,
    fill: "#C5BFA7"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 28,
    width: 1,
    height: 1,
    fill: "#70664B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriestRightArmTop);
export default __webpack_public_path__ + "static/media/priest-RightArmTop.436b1686742d20ed5516fb4e11187ead.svg";
export { ForwardRef as ReactComponent };